<template>
  <div class="header">

    <div class="header-left">
      <div class="collapse-btn" @click="collapseChage">
        <i v-if="!collapse" class="el-icon-s-fold"></i>
        <i v-else class="el-icon-s-unfold"></i>
      </div>
      <!-- <el-image   v-if="logoShow&&logoPosition=='right'" class="header-logo" :src="url"  fit="scale-down"></el-image> -->
      <span   v-if="logoShow&&logoPosition=='right'" class="header-appname">{{appName}}{{subName}}</span>
    </div>
    <!--  <div class="logo">
      <span style="font-size: 24px;margin-left: 5px">{{appName}}{{secName}}</span>
    </div> -->
    <!--    <div class="logo_time">
      <p style="font-size: 20px"></p>
    </div> -->

    <div class="header-right">
      <div class="header-time">
        {{nowTime}}年{{nowTime1}}月{{nowTime2}}日&nbsp;{{nowTime3}}
      </div>
      <div class="btn-setting" @click="handleSetting">
        <el-tooltip effect="dark" :content="'设置'" placement="bottom">
          <i class="el-icon-setting"></i>
        </el-tooltip>
      </div>
      <div class="btn-fullscreen" @click="handleFullScreen">
        <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
          <i class="el-icon-rank"></i>
        </el-tooltip>
      </div>
      <!-- 消息中心 -->
      <div class="btn-bell" @click="toNext">
        <el-tooltip effect="dark" :content="`有${scheduleCount}条未读消息`" placement="bottom">
          <el-badge :value="scheduleCount" class="badge-schedule">
            <i class="el-icon-bell"></i>
          </el-badge>
        </el-tooltip>
      </div>
      <!-- 用户头像 -->
      <!-- <div class="user-avator">
          <img src="../../../assets/img/img.jpg" />
        </div> -->
      <!-- 用户名下拉菜单 -->
      <el-dropdown class="username-drop" trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
           {{userName}}
          <i class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="problem">问题反馈</el-dropdown-item>
          <el-dropdown-item command="operation">操作手册</el-dropdown-item>
          <!--            <el-dropdown-item command="coderule">编码体系</el-dropdown-item>
            <el-dropdown-item command="userlist">用户列表</el-dropdown-item> -->
          <el-dropdown-item divided> </el-dropdown-item>
          <el-dropdown-item command="modifyPassword">修改密码</el-dropdown-item>
          <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

    </div>
  </div>
</template>


<script>
  import axios from '@/axios'
  import {
    mapState,
    mapGetters
  } from 'vuex'
  export default {
    computed: {
      count() {
        return this.$store.getters.waitToAll
      },

    ...mapGetters([  'logoShow', 'logoPosition' ]),

      ...mapState({
        serverName: state => state.app.serverName,
        appName: state => state.app.appName,
        subName: state => state.app.subName,
        secName: state => state.app.secName,
        scheduleCount: state => state.process.scheduleCount,
      })
    },
    data() {
      return {
        color1: '#DAD8D9',
        changeColor: '#409eff',
        color2: '#C7C8E6',
        color3: '#FCE2D3',
        color4: '#50B28A',
        userName: "Louis",
        loginName: '',
        dialogVisible: false,
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: "",
        totalRows: "",
        currentPage: 1,
        pageSize: 10,


        collapse: false,
        fullscreen: false,
        name: 'linxin',
        message: 2,
        nowTime: '',
        nowTime1: '',
        nowTime2: '',
        nowTime3: '',

        // url: require('../../../assets/img/sd.png'),
      }
    },
    components: {

    },
    methods: {
      getTime() {
        var date = new Date()
        this.nowTime = date.getFullYear()
        this.nowTime1 = (date.getMonth() + 1).toString()
        this.nowTime2 = date.getDate().toString()
        this.nowTime3 = "星期" + "日一二三四五六".charAt(date.getDay())
      },
      created() {
        // this.getTime();
      },
      // 侧边栏折叠
      collapseChage() {
        this.collapse = !this.collapse;
        this.$store.commit('setCollapse', this.collapse)
      },
      handleSetting() {
        this.$store.commit('setSetting')
      },
      // 全屏事件
      handleFullScreen() {
        let element = document.documentElement;
        if (this.fullscreen) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        } else {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
          } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
          } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
          }
        }
        this.fullscreen = !this.fullscreen;
      },
      handleCommand(command) {
        switch (command) {
          case 'logout':
            //this.logout()
            this.$message('click on item ' + command);
            break
          case 'modifyPassword':
            //this.dialogVisible = true
            this.$router.push('/home/modifyPassword')
            console.log('编辑密码')
            break
          case 'problem':
            this.$router.push('/home/problemList')
            break
          case 'operation':
            window.open(this.serverName + '/Common/downloadByStream.do?id=' + '70C5646250AA47CB8B79277C60BA2B52')
            break
          case 'coderule':
            window.open(this.serverName + '/Common/downloadByStream.do?id=' + 'B27513C0CF8242E387B292329DBEA461')
            break
          case 'userlist':
            window.open(this.serverName + '/Common/downloadByStream.do?id=' + '7ED5289FE1084454A69111DEFAB77D6D')
            break
        }
      },
      editPawSubmit() {
        this.$message('click on item ' + this.newPassword);
      },
      getWaitDo() {

        var url = 'framework/CommonSchedule/queryByUserId.do'
        var param = {
          page: 1,
          rows: 10000,
        }
        axios.get(url, param).then(response => {
          this.$store.commit('setScheduleCount', response.data.data.total)
        });


      },

      toNext() {
        this.$router.push({
          path: '/process/schedule',
          // meta: {
          // 	keepAlive: false
          // }
        })
      },
      toHome() {
        this.$router.push({
          path: '/home/main',
          // meta: {
          // 	keepAlive: false
          // }
        })
      },

      logout: function() {
        var _this = this;
        this.$confirm("确认退出吗?", "提示", {
          type: "warning"
        }).then(() => {
          //localStorage.clear()

          localStorage.setItem('userId', '')
          localStorage.setItem('loginName', '')
          localStorage.setItem('userName', '')
          localStorage.setItem('token', '')
          localStorage.setItem('wares', '')
          //sessionStorage.clear()
          this.$store.commit('setOpenedPageList', [])
          this.$store.commit('setMenuLoaded', false)
          this.$store.commit('setRouteLoaded', false)
          this.$router.push("/login")
        }).catch(() => {});
      }
    },
    mounted() {
      this.getTime()
      if (document.body.clientWidth < 1500) {
        this.collapseChage();
      }
      this.getWaitDo()

      var userName = localStorage.getItem("userName")
      if (userName) {
        this.userName = userName
      }
      var loginName = localStorage.getItem("loginName")
      if (loginName) {
        this.loginName = loginName
      }
    },

    // beforeRouteLeave(to, from, next) {
    // 	to.meta.keepAlive = false
    // 	next();
    // }
  }
</script>
<style scoped>
  .header {

/*    background-color: #304156;
 color: #FFFFFF; */
background-color: #FFFFFF;
     color: #304156;
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

  }

  .header-left {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

  }

  .collapse-btn {
    /*    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 60px; */

    padding-left: 21px;
    font-size: 24px;
  }

  .header-logo {
    margin-left: 20px;
    width: 50px;
    height: 50px;
  }

  .header-appname {
    margin-left: 5px;
    font-size: 24px;
  }



  .header-right {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .header-time {
    margin-right: 20px;
  }

  .btn-setting {
    transform: rotate(30deg);
    margin-right: 10px;
    font-size: 24px;
  }

  .btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 10px;
    font-size: 24px;
  }

  .btn-bell {
    margin-right: 10px;
    font-size: 24px;
  }

  .username-drop {
    margin-right: 20px;
    color: #000000;
  }

  .badge-schedule {
    margin-top: -7px;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/framework/home/HeaderBar.vue